import { createStore } from 'vuex';

import settings from "../settings";

// modules
import specialists from './modules/specialists.js';
import services from './modules/services.js';

// plugin
// import plugin from './plugins/';

const state = {
  home: settings.home,
  gallery: settings.gallery,
  doctors: settings.doctors,
  filters: {
    serviceTyp: settings.serviceTyp,
    sex: settings.sex,
  },
  links: settings.links,
  forms: settings.forms
};

const getters = {

};

const mutations = {};

const actions = {};

const store = createStore({
  state,
  getters,
  mutations,
  actions,
  modules: {
    specialists,
    services
  },
  plugins: [
    //plugin
  ]
});

export default store
